export const getKnowledgeStatusByNumber = (bitNumber, formatMessage) => {
	let statusToReturn = [formatMessage({ id: "registraion.knowledge.option1" })];

	if (bitNumber === 2 || bitNumber === 3) {
		statusToReturn.push(formatMessage({ id: "registraion.knowledge.option2" }));
	}

	if (bitNumber === 4 || bitNumber === 5) {
		statusToReturn.push(formatMessage({ id: "registraion.knowledge.option3" }));
	}

	if (bitNumber === 6 || bitNumber === 7) {
		statusToReturn.push(formatMessage({ id: "registraion.knowledge.option2" }));
		statusToReturn.push(formatMessage({ id: "registraion.knowledge.option3" }));
	}

	return statusToReturn;
};
